import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { Globals } from '../_globals';
import { StoreService } from 'app/_services/store.service';
import { DashboardService } from 'app/_services/dashboard.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
    @ViewChild(BaseChartDirective) chart: BaseChartDirective;

    public canvas: any;
    public ctx;
    public gradientFill;
    public chartColor;

    role: any;
    routeRole: any;

    cookieStore: any;

    todayStats: any;
    monthStats: any;
    yearStats: any;

    public lineBigDashboardChartType;
    public lineBigDashboardChartData: Array<any>;
    public lineBigDashboardChartOptions: any;
    public lineBigDashboardChartLabels: Array<any>;
    public lineBigDashboardChartColors: Array<any>;

    constructor(
        public _authService: AuthService,
        public globals: Globals,
        public _storeService: StoreService,
        public _dashboardService: DashboardService,
        public cookieService: CookieService,
        public router: Router
    ) {
        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }
    }

    // events
    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    ngOnInit() {
        // console.log('this.cookieStore', this.cookieStore);

        this.chartColor = '#FFFFFF';
        this.canvas = document.getElementById('bigDashboardChart');
        this.ctx = this.canvas.getContext('2d');

        this.gradientFill = this.ctx.createLinearGradient(0, 200, 0, 50);
        this.gradientFill.addColorStop(0, 'rgba(128, 182, 244, 0)');
        this.gradientFill.addColorStop(1, 'rgba(255, 255, 255, 0.24)');

        this.lineBigDashboardChartData = [
            {
                label: this.cookieStore.currency,

                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 5,
                fill: true,

                borderWidth: 2,
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
        ];
        this.lineBigDashboardChartColors = [
            {
                backgroundColor: this.gradientFill,
                borderColor: this.chartColor,
                pointBorderColor: this.chartColor,
                pointBackgroundColor: '#2c2c2c',
                pointHoverBackgroundColor: '#2c2c2c',
                pointHoverBorderColor: this.chartColor,
            },
        ];
        this.lineBigDashboardChartLabels = [
            'JAN',
            'FEB',
            'MAR',
            'APR',
            'MAY',
            'JUN',
            'JUL',
            'AUG',
            'SEP',
            'OCT',
            'NOV',
            'DEC',
        ];
        this.lineBigDashboardChartOptions = {
            layout: {
                padding: {
                    left: 20,
                    right: 20,
                    top: 0,
                    bottom: 0,
                },
            },
            maintainAspectRatio: false,
            tooltips: {
                backgroundColor: '#fff',
                titleFontColor: '#333',
                bodyFontColor: '#666',
                bodySpacing: 4,
                xPadding: 12,
                mode: 'nearest',
                intersect: 0,
                position: 'nearest',
            },
            legend: {
                position: 'bottom',
                fillStyle: '#FFF',
                display: false,
            },
            scales: {
                yAxes: [
                    {
                        ticks: {
                            fontColor: 'rgba(255,255,255,0.4)',
                            fontStyle: 'bold',
                            beginAtZero: true,
                            maxTicksLimit: 5,
                            padding: 10,
                        },
                        gridLines: {
                            drawTicks: true,
                            drawBorder: false,
                            display: true,
                            color: 'rgba(255,255,255,0.1)',
                            zeroLineColor: 'transparent',
                        },
                    },
                ],
                xAxes: [
                    {
                        gridLines: {
                            zeroLineColor: 'transparent',
                            display: false,
                        },
                        ticks: {
                            padding: 10,
                            fontColor: 'rgba(255,255,255,0.4)',
                            fontStyle: 'bold',
                        },
                    },
                ],
            },
        };

        this.lineBigDashboardChartType = 'line';

        this.getBigChartData(this.cookieStore.id);
        this.getTodayData(this.cookieStore.id);
        this.getThisMonthData(this.cookieStore.id);
        this.getThisYearData(this.cookieStore.id);
    }

    public getBigChartData(id) {
        // console.log('getBigChartData', id);

        for (let i = 0; i < 12; i++) {
            const date = new Date();

            const month = new Date(date.getFullYear(), 0 + i, 1);

            const firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
            const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);
            lastDay.setHours(23);
            lastDay.setMinutes(59);
            lastDay.setSeconds(59);

            // console.log(firstDay + ' - ' + lastDay);
            this._dashboardService
                .getStoreStats(id, firstDay.getTime(), lastDay.getTime())
                .subscribe((data: any) => {
                    // console.log(firstDay + ' - ' + lastDay + ' : ' + data.totalSpend);
                    this.lineBigDashboardChartData[0].data[i] = data.totalSpend;
                    if (this.chart && this.chart.chart) {
                        this.chart.chart.update();
                    }
                    // console.log(this.lineBigDashboardChartData);
                });
        }
    }

    public getTodayData(id) {
        const start = new Date();
        const end = new Date();

        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);

        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);

        // console.log('getTodayData', start + ' - ' + end);

        this._dashboardService
            .getStoreStats(id, start.getTime(), end.getTime())
            .subscribe((data: any) => {
                this.todayStats = data;
                // console.log('todayStats', this.todayStats);
            });
    }

    public getThisMonthData(id) {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        lastDay.setHours(23);
        lastDay.setMinutes(59);
        lastDay.setSeconds(59);

        // console.log('getThisMonthData', firstDay + ' - ' + lastDay);

        this._dashboardService
            .getStoreStats(id, firstDay.getTime(), lastDay.getTime())
            .subscribe((data: any) => {
                this.monthStats = data;
                // console.log('monthStats', this.monthStats);
            });
    }

    public getThisYearData(id) {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), 0, 1);
        const lastDay = new Date(date.getFullYear(), 11, 31);

        lastDay.setHours(23);
        lastDay.setMinutes(59);
        lastDay.setSeconds(59);

        // console.log('getThisYearData', firstDay + ' - ' + lastDay);

        this._dashboardService
            .getStoreStats(id, firstDay.getTime(), lastDay.getTime())
            .subscribe((data: any) => {
                this.yearStats = data;
                // console.log('yearStats', this.yearStats);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts